import React from 'react';
import ConfidenceIndicator from './ConfidenceIndicator';
import PriorityFlag from './PriorityFlag';
interface EvidenceCardProps {
  title: string;
  source: string;
  submissionCount: number;
  validationStatus: 'validated' | 'conflicting' | 'unverified';
  priority: 'low' | 'medium' | 'high' | 'critical';
  confidence: number;
}
const EvidenceCard: React.FC<EvidenceCardProps> = ({
  title,
  source,
  submissionCount,
  validationStatus,
  priority,
  confidence
}) => {
  const getValidationBadge = () => {
    switch (validationStatus) {
      case 'validated':
        return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-18">
            Validated
          </span>;
      case 'conflicting':
        return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-200 text-blue-800" data-id="element-19">
            Conflicting
          </span>;
      case 'unverified':
        return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-300 text-blue-800" data-id="element-20">
            Unverified
          </span>;
    }
  };
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-21">
      <div className="p-5" data-id="element-22">
        <div className="flex justify-between items-start" data-id="element-23">
          <div data-id="element-24">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-25">{title}</h3>
            <p className="text-sm text-gray-500 mt-1" data-id="element-26">Source: {source}</p>
          </div>
          <div className="flex space-x-2" data-id="element-27">
            <PriorityFlag level={priority} data-id="element-28" />
            {getValidationBadge()}
          </div>
        </div>
        <p className="mt-3 text-sm text-gray-600" data-id="element-29">
          Referenced in {submissionCount} submissions
        </p>
        <div className="mt-4 flex justify-between items-center" data-id="element-30">
          <ConfidenceIndicator score={confidence} data-id="element-31" />
          <button className="text-sm text-blue-600 hover:text-blue-500 font-medium" data-id="element-32">
            View details
          </button>
        </div>
      </div>
    </div>;
};
export default EvidenceCard;